app.controller("EditSubjectWrapperController", [
    "$scope", "StaticData", "$uibModalInstance", "Subject", "params", "InfoModal", "toastr",
    function ($scope, StaticData, $uibModalInstance, Subject, params, InfoModal, toastr) {
        var semesters = params.semesters;
        $scope.semesters = _.range(1, semesters + 1);
        $scope.semesters.unshift(null);
        $scope.level = params.program ? params.program.level : null;

        StaticData.getItemsByKey("subject_seasons").then(function (data) {
            $scope.seasons = data;
        });

        setTimeout(function () {
            $scope.wrapper = params.wrapper;
            $scope.subjectList = null;
            var seasons = $scope.seasons.filter(function (s) {
                return s._id === $scope.wrapper.season
            });
            $scope.season = seasons && seasons.length ? seasons[0] : null;
            $scope.semester = $scope.wrapper.semester;
            $scope.query = "";
            $scope.chosenSubject = $scope.wrapper.subject;
            $scope.program = params.program;
            $scope.name = $scope.wrapper.name;
            $scope.equals = $scope.wrapper.equals && $scope.wrapper.equals.length ? $scope.wrapper.equals[0] : null;
            $scope.newDependency = null;
            $scope.dep_id = "";
            $scope.dependencies = [];
            $scope.wrapper.prerequisites.forEach(function (dep) {
                return Subject.fetchOne(dep)
                    .then(function (data) {
                        return $scope.dependencies.push(data.subject)
                    })
            });
            $scope.credits = params.wrapper.credits;
            $scope.preCredits = params.wrapper.preCredits || 0;
        }, 10);

        $scope.$watch('newDependency', function (val) {
            if (val && val._id) {
                $scope.dependencies.push(val);
                $scope.newDependency = null;
            }
        }, true);

        // ?? რა საჭიროა ??
        // $scope.$watch('chosenSubject', function (val) {
        //     if (val && val._id) {
        //         $scope.credits = val.credits;
        //         $scope.name = val.name;
        //         for (var i in $scope.dependencies) {
        //             var dep = $scope.dependencies[i];
        //             if (val._id == dep._id) {
        //                 $scope.dependencies.splice(i, 1)
        //             }
        //         }
        //     }
        // }, true);

        $scope.delete_dependency = function (dep) {

            var el_index = _.findIndex($scope.dependencies, function (dependency) {
                return dependency._id === dep._id;
            });

            $scope.dependencies.splice(el_index, 1);
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query, level: $scope.level}).then(function (data) {
                return data.docs.filter(function (subj) {
                    var el_index = _.findIndex($scope.dependencies, function (dependency) {
                        return dependency._id === subj._id;
                    });

                    if ($scope.chosenSubject && $scope.chosenSubject._id === subj._id) {
                        return false;
                    }

                    return el_index === -1;
                })
            });
        };

        $scope.changeSeason = function () {
            var value = $scope.semester;
            $scope.season = $scope.seasons[value % 2]
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.edit = function () {
            var prerequisites_list = $scope.dependencies.map(function (el) {
                return el._id
            });

            if (!$scope.chosenSubject || !$scope.chosenSubject._id) {
                return InfoModal.show({message: "მითითებული საგანი არ არსებობს!!! გთხოვთ სწორად მიუთითოთ საგნის სახელი."});
            }
            if ($scope.season) {
                $scope.wrapper.season = $scope.season._id;
            }
            // $scope.wrapper.name = $scope.name;
            $scope.wrapper.semester = $scope.semester;
            $scope.wrapper.subjectId = $scope.chosenSubject._id;
            $scope.wrapper.lecturerId = "";
            $scope.wrapper.preCredits = $scope.preCredits;
            $scope.wrapper.credits = $scope.credits;
            $scope.wrapper.program = $scope.program;
            $scope.wrapper.equals = $scope.equals ? [$scope.equals._id] : null;
            $scope.wrapper.prerequisites = prerequisites_list;
            params.method($scope.wrapper).then(function () {
                $uibModalInstance.close();
                toastr.success('', 'საგანი შეცვლილია');
            });
        };
    }
]);
